import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BRAND } from "@/constants/testIds";

/** Once-per-session ceremonial splash — logo breathing on matte black. */
export default function Splash() {
  const [show, setShow] = useState(() => !sessionStorage.getItem("av_splash_seen"));

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("av_splash_seen", "1");
    const t = setTimeout(() => setShow(false), 2600);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid={BRAND.splash}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.1, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#080808] pointer-events-none"
        >
          <motion.img
            src="/brand/auraveil-logo.png"
            alt="AuraVeil"
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.6, ease: "easeInOut" }}
            className="w-[300px] sm:w-[420px] select-none"
            style={{ mixBlendMode: "screen" }}
            draggable={false}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
